import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useGetContractorGus, validateNIP } from 'api';

import { Input } from 'components/ui';

import * as Styled from './General.styles';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

export const General = ({ form, setToastData, isNipDisabled }) => {
  const [isNipValidation, setIsNipValidation] = useState(false);

  const { values, errors, setFieldValue, setFieldError, setValues } = form;

  const { refetch: fetchDataFromGus, isRefetching: isFetchingDataFromGus } = useGetContractorGus(values.nip.nip, {
    enabled: false,
    onSuccess: (data) => {
      data && setValues(data);
      setToastData({ severity: 'success', message: 'Pobrano dane z GUS' });
    },
    onError: () => {
      setToastData({ severity: 'error', message: 'Nie udało się pobrać danych z GUS' });
    },
  });

  const handleFetchFromGUS = async () => {
    setIsNipValidation(true);
    setFieldError('nip.nip', null);
    const isNipValid = await validateNIP(values.nip.nip);
    setIsNipValidation(false);

    if (!isNipValid) {
      return setFieldError('nip.nip', "'Niepoprawny NIP'");
    }

    fetchDataFromGus();
  };

  return (
    <Styled.Wrapper>
      <Styled.Row>
        <Input
          onChange={(value) => setFieldValue('nip.nip', value)}
          value={values.nip.nip}
          label="NIP*"
          error={(errors.nip || {}).nip}
          disabled={isNipDisabled}
        />

        <Styled.GusButton
          color="white"
          onClick={handleFetchFromGUS}
          loading={isNipValidation || isFetchingDataFromGus}
          disabled={isNipDisabled}
        >
          <CloudDownloadIcon />
          GUS
        </Styled.GusButton>
      </Styled.Row>

      <Input
        onChange={(value) => setFieldValue('name', value)}
        value={values.name}
        label="Nazwa*"
        error={errors.name}
      />
    </Styled.Wrapper>
  );
};

General.propTypes = {
  form: PropTypes.object.isRequired,
  setToastData: PropTypes.func.isRequired,
  isNipDisabled: PropTypes.bool.isRequired,
};
